import {
  requestPost,
  requestGet
} from "../config/Api";

const name = "news/legal/file";

export const getNewsFailed = (params) => {
  return requestGet(`${name}/failed`, { params });
};

export const createNewLegalFile = (legalFile) => {
  return requestPost(`${name}/generate`, legalFile);
};